/* eslint-disable */
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import "./userMangementFilter.css";

const FILTER_FUNCTIONS = {
	contains: "contains",
	not_contains: "not_contains",
	equals: "equals",
	not_equals: "not_equals",
	starts_with: "starts_with",
	ends_with: "ends_with"
};

export default forwardRef((props, ref) => {
	const [filterText, setFilterText] = useState(""); // ✅ always a string
	const [filterType, setFilterType] = useState(FILTER_FUNCTIONS.starts_with);
	const [search, setSearch] = useState(false);

	const inputRef = useRef(null);
	const selectRef = useRef(null);

	const { schema, setGridFilterSchema } = props.frameworkComponentWrapper.agGridReact.props.frameworkComponents;

	useImperativeHandle(ref, () => {
		return {
			getModel() {
				// ✅ Always return a string (never undefined/null)
				return filterText ?? "";
			},

			setModel(model) {
				setFilterText(model ?? "");
			},

			myMethodForTakingValueFromFloatingFilter(value) {
				setFilterText(value ?? "");
			},

			handleSearch() {
				setSearch(true);
			}
		};
	});

	const onInputBoxChanged = useDebouncedCallback(async (event) => {
		setFilterText(event.target.value ?? ""); // ✅ normalize input
	}, 300);

	const onSelectChanged = (event) => {
		setFilterType(event.target.value);
	};

	useEffect(() => {
		if (!search) return;

		// Update the floating input & select
		if (inputRef.current) inputRef.current.value = filterText;
		if (selectRef.current) selectRef.current.value = filterType;

		// Notify AG Grid the filter changed
		props.filterChangedCallback();

		// Update payload schema (shared state)
		setGridFilterSchema({
			...schema,
			[props.column.colDef.field]: {
				value: filterText,
				type: filterType
			}
		});

		// ✅ Call parent onFilterChange
		if (props.onFilterChange) {
			props.onFilterChange({
				...schema,
				[props.column.colDef.field]: {
					value: filterText,
					type: filterType
				}
			});
		}

		setSearch(false);
	}, [filterText, filterType, search]);

	return (
		<div className="custom-ag-icon">
			<div style={{ padding: "4px" }} className="customFilter">
				<div className="filter-container">
					<select
						className="customFilterInput"
						ref={selectRef}
						style={{ margin: "4px 0", padding: "0px" }}
						onInput={onSelectChanged}
						defaultValue={FILTER_FUNCTIONS.starts_with}
					>
						<option value={FILTER_FUNCTIONS.starts_with}>Starts with</option>
						{/* Uncomment if you want more filter options */}
						{/* <option value={FILTER_FUNCTIONS.contains}>Contains</option>
						<option value={FILTER_FUNCTIONS.not_contains}>Not contains</option>
						<option value={FILTER_FUNCTIONS.equals}>Equals</option>
						<option value={FILTER_FUNCTIONS.not_equals}>Not equals</option>
						<option value={FILTER_FUNCTIONS.ends_with}>Ends with</option> */}
					</select>

					<input
						className="customFilterInput"
						ref={inputRef}
						style={{ margin: "4px 0" }}
						onInput={onInputBoxChanged}
						placeholder="Filter..."
					/>
				</div>
			</div>
		</div>
	);
});
